import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { InputEditorComponent } from '../joi-input/input-editor';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';

@Component({
    selector: 'input-editor-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="data.backgroundColor || defaultColor"
  [dialogTitle]="data.title"
  [smallTitle]="true"
  [tiny]="true"
  [disabled]="false"
  [giveMeTwenty]="true"
  [titleHeight]="40"
  [cancelLeft]="true"
  [data]="data.position ? { position: data.position, dialogRef: dialogRef } : null"
  (cancel)="dialogRef.close()"
  (submit)="dialogRef.close(data)"
>
  <input-editor
    [object]="data" 
    [prop]="'text'"
    [placeholder]="data.placeholder"
  ></input-editor>
</dialog-wrapper>
`,
    styles: [`
    input-editor { margin-bottom: 15px; }
  `],
    standalone: true,
    imports: [DialogWrapperComponent, InputEditorComponent ]
})
export class InputEditorDialogComponent {
  defaultColor: string = null

  constructor(
    public dialogRef: MatDialogRef<InputEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputEditorDialogData,
  ) {}
}

export interface InputEditorDialogData {
  text: string 
  title: string
  placeholder: string
  backgroundColor?: string
  position?: DialogPositionNumbers
}